import {
    GET_INVESTMENTS,
    GET_INVESTMENT_DETAILS,
    CREATE_INVESTMENT,
    UPDATE_INVESTMENT,
    DELETE_INVESTMENT,
    CALCULATE_INVESTMENT_PREVIEW,
    CLEAR_INVESTMENT_PREVIEW,
    MATURE_INVESTMENT,
    PRE_MATURE_INVESTMENT,
    RENEW_INVESTMENT,
    CLEAR_INVESTMENT_STATE,
} from '../../index.types';

export function getInvestments(data) {
    return { type: GET_INVESTMENTS, data };
}

export function getInvestmentDetails(data) {
    return { type: GET_INVESTMENT_DETAILS, data };
}

export function createInvestment(data) {
    return { type: CREATE_INVESTMENT, data };
}

export function updateInvestment(data) {
    return { type: UPDATE_INVESTMENT, data };
}

export function deleteInvestment(data) {
    return { type: DELETE_INVESTMENT, data };
}

export function calculateInvestmentPreview(data) {
    return { type: CALCULATE_INVESTMENT_PREVIEW, data };
}

export function clearInvestmentPreview() {
    return { type: CLEAR_INVESTMENT_PREVIEW };
}

export function matureInvestment(data) {
    return { type: MATURE_INVESTMENT, data };
}

export function preMatureInvestment(data) {
    return { type: PRE_MATURE_INVESTMENT, data };
}

export function renewInvestment(data) {
    return { type: RENEW_INVESTMENT, data };
}

export function clearInvestmentState() {
    return { type: CLEAR_INVESTMENT_STATE };
}
